import { $enum } from 'ts-enum-util'
import { IShipmentIssueTypeSlaBasedOn } from 'types/graphqlTypes'
import * as yup from 'yup'
import { ISSUE_TYPE_DEFAULTS } from '../utils/getDefaultValuesFromIssue'

const REQUIRED_MESSAGE = 'This field is required'

const SubscribersSchema = yup.object({
  id: yup.number(),
  text: yup.string(),
  type: yup.string(),
  value: yup.string(),
  label: yup.string(),
})

export const IssueTypeFormSchema = yup
  .object({
    id: yup.number(),
    name: yup.string().required(REQUIRED_MESSAGE),
    description: yup.string(),
    shipmentIssueCategoryId: yup.number().required(REQUIRED_MESSAGE),
    shipmentIssueTypeDefaultOwner: yup.string(),
    shipmentIssueTypeDefaultSubscribers: yup.array().of(SubscribersSchema),
    defaultPriority: yup.number().min(1).max(4).default(ISSUE_TYPE_DEFAULTS.defaultPriority),
    slaDuration: yup
      .number()
      .min(0)
      .required(REQUIRED_MESSAGE)
      .default(ISSUE_TYPE_DEFAULTS.slaDuration),
    slaBasedOn: yup
      .mixed<IShipmentIssueTypeSlaBasedOn>()
      .required(REQUIRED_MESSAGE)
      .oneOf([...$enum(IShipmentIssueTypeSlaBasedOn).getValues()])
      .default(IShipmentIssueTypeSlaBasedOn.issue_creation),
    issueResolutionSteps: yup.array(
      yup.object({
        id: yup.string(),
        name: yup.string().required(REQUIRED_MESSAGE),
      })
    ),
  })
  .required()

export type TIssueTypeFormSchema = yup.InferType<typeof IssueTypeFormSchema>
